import React, { useEffect } from 'react';
import QualityComplianceTracker from '../components/QualityComplianceTracker';

export default function QualityCompliancePage() {
  useEffect(() => {
    document.body.classList.add('analytics-page');
    return () => {
      document.body.classList.remove('analytics-page');
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc', paddingTop: '60px' }}>
      <QualityComplianceTracker vendorId="vendor-001" isStaffView={true} />
    </div>
  );
}